import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import buyerApi from '@/lib/marketplaceCustomerApi';

const BuyerAuthContext = createContext(null);

export const BuyerAuthProvider = ({ children }) => {
  const [buyer, setBuyer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshBuyer = useCallback(async () => {
    try {
      const response = await buyerApi.get('/me');
      setBuyer(response.data);
      return response.data;
    } catch (error) {
      setBuyer(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshBuyer();
  }, [refreshBuyer]);

  const logoutBuyer = useCallback(async () => {
    try {
      await buyerApi.post('/logout');
    } finally {
      setBuyer(null);
      window.dispatchEvent(new CustomEvent('learnAuthChanged', { detail: { authenticated: false } }));
    }
  }, []);

  const value = useMemo(() => ({
    buyer,
    loading,
    isAuthenticated: Boolean(buyer),
    refreshBuyer,
    logoutBuyer,
  }), [buyer, loading, refreshBuyer, logoutBuyer]);

  return <BuyerAuthContext.Provider value={value}>{children}</BuyerAuthContext.Provider>;
};

export const useBuyerAuth = () => {
  const context = useContext(BuyerAuthContext);
  if (!context) {
    throw new Error('useBuyerAuth must be used within a BuyerAuthProvider');
  }
  return context;
};
